import { render } from "./UhOh.vue?vue&type=template&id=964f7a70&scoped=true"
import script from "./UhOh.vue?vue&type=script&lang=js"
export * from "./UhOh.vue?vue&type=script&lang=js"

import "./UhOh.vue?vue&type=style&index=0&id=964f7a70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-964f7a70"]])

export default __exports__